/* eslint-disable jsx-a11y/alt-text */
import React from 'react';
import RadioComponent from 'shared/components/RadioComponent';
import Tooltip from 'shared/components/Tooltip';
import Label from 'shared/components/Label';

const PressureHolderType = (props) => {
  const {
    name,
    parameters,
    onChangeParameter,
    label,
    required,
    tooltip,
    inputClassName,
    yesValue,
    noValue,
    yesLabel,
    noLabel,
    children,
  } = props;

  const onChange = e => onChangeParameter(name, e.target.value);
  const value = parameters[name];

  return (
    <div className="form-group">
      <Label label={label} required={required}>
        <Tooltip id={`tooltip-${name}`} title={tooltip} />
      </Label>
      <div className="row">
        <div className="col-12">
          <RadioComponent
            {...props}
            checked={value === 'none'}
            inputId="pressure-holder-type-none"
            inputClassName={inputClassName}
            label="None"
            name={name}
            onChange={onChange}
            value="none" />
        </div>
        <div className="col-lg-6">
          <RadioComponent
            {...props}
            checked={value === noValue}
            inputId="pressure-holder-type-a"
            inputClassName={inputClassName}
            label={noLabel}
            name={name}
            onChange={onChange}
            value={noValue} />
          <img src={Spree.image_assets.type_flexible} className="img-fluid" />
        </div>
        <div className="col-lg-6">
          <RadioComponent
            {...props}
            checked={value === yesValue}
            inputId="pressure-holder-type-b"
            inputClassName={inputClassName}
            label={yesLabel}
            name={name}
            onChange={onChange}
            value={yesValue} />
          <img src={Spree.image_assets.type_standard} className="img-fluid" />
        </div>
      </div>
      {children}
    </div>
  );
};

PressureHolderType.defaultProps = {
  name: 'pressure_holder_type',
  noLabel: 'Standard ($2 each)',
  noValue: 'standard-holder',
  yesLabel: 'Flexible (No charge)',
  yesValue: 'flexible-holder',
  label: 'What kind of pressure holders do you need?',
  required: true,
};

export default PressureHolderType;
